import { Button, Icon, MenuNested } from "@saviynt/design-system";
import { FormattedMessage, useIntl } from "react-intl";

interface IntegrationsSortMenuProps {
  onSortChange: (field: string, direction: string) => void;
}

export function IntegrationsSortMenu({
  onSortChange,
}: IntegrationsSortMenuProps) {
  const intl = useIntl();

  // Define messages as constants to satisfy formatjs/enforce-id
  const createdOnLabel = intl.formatMessage({
    id: "Ir+fxa",
    defaultMessage: "Created On",
    description: "Sort by created date option",
  });
  const updatedOnLabel = intl.formatMessage({
    id: "44FYET",
    defaultMessage: "Updated On",
    description: "Sort by updated date option",
  });
  const connectionSourceLabel = intl.formatMessage({
    id: "PVoIza",
    defaultMessage: "Connection Source",
    description: "Sort by connection source option",
  });
  const integrationNameLabel = intl.formatMessage({
    id: "AKDNWG",
    defaultMessage: "Integration Name",
    description: "Sort by integration name option",
  });
  const ascendingLabel = intl.formatMessage({
    id: "SwIggS",
    defaultMessage: "Ascending",
    description: "Ascending sort option",
  });
  const descendingLabel = intl.formatMessage({
    id: "RBA5/j",
    defaultMessage: "Descending",
    description: "Descending sort option",
  });

  return (
    <MenuNested
      trigger={
        <Button
          kind="outlined"
          size="medium"
          leftIcon={<Icon kind="Sort" size="small" />}
          className="h-10 px-3"
        >
          <FormattedMessage
            id="M4ietC"
            defaultMessage="Sort"
            description="Sort button label"
          />
        </Button>
      }
      shouldCloseMenuOnItemClick
    >
      <MenuNested
        shouldHoverOpenSubMenu
        label={createdOnLabel}
        options={[
          {
            label: ascendingLabel,
            value: "ASC",
            icon: "ArrowUp",
          },
          {
            label: descendingLabel,
            value: "DESC",
            icon: "ArrowDown",
          },
        ]}
        onOptionChange={(option: { value?: string; label?: string }) => {
          if (option.value) {
            onSortChange("createdDate", option.value);
          }
        }}
        shouldCloseMenuOnItemClick
      />
      <MenuNested
        shouldHoverOpenSubMenu
        label={updatedOnLabel}
        options={[
          {
            label: ascendingLabel,
            value: "ASC",
            icon: "ArrowUp",
          },
          {
            label: descendingLabel,
            value: "DESC",
            icon: "ArrowDown",
          },
        ]}
        onOptionChange={(option: { value?: string; label?: string }) => {
          if (option.value) {
            onSortChange("updatedDate", option.value);
          }
        }}
        shouldCloseMenuOnItemClick
      />
      <MenuNested
        shouldHoverOpenSubMenu
        label={connectionSourceLabel}
        options={[
          {
            label: ascendingLabel,
            value: "ASC",
            icon: "ArrowUp",
          },
          {
            label: descendingLabel,
            value: "DESC",
            icon: "ArrowDown",
          },
        ]}
        onOptionChange={(option: { value?: string; label?: string }) => {
          if (option.value) {
            onSortChange("integrationType", option.value);
          }
        }}
        shouldCloseMenuOnItemClick
      />
      <MenuNested
        shouldHoverOpenSubMenu
        label={integrationNameLabel}
        options={[
          {
            label: ascendingLabel,
            value: "ASC",
            icon: "ArrowUp",
          },
          {
            label: descendingLabel,
            value: "DESC",
            icon: "ArrowDown",
          },
        ]}
        onOptionChange={(option: { value?: string; label?: string }) => {
          if (option.value) {
            onSortChange("displayName", option.value);
          }
        }}
        shouldCloseMenuOnItemClick
      />
    </MenuNested>
  );
}
